import { Component , OnDestroy} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy{
  title = 'Angular';
  routerSubscribe: Subscription
  isMap: boolean = false;

  constructor(private router: Router) {
    this.routerSubscribe = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd ){
        if(event.url.split(';')[0] == '/map') {
          this.isMap = true;
        }
        else {
          this.isMap = false;
        }
      }
    })
  }

  ngOnDestroy() {
    this.routerSubscribe.unsubscribe();
  }
  
}